import { buildColumn, EditableColumnConfig } from '~components/table-view';

const columns: EditableColumnConfig[] = [
  {
    id: 'sah_budget_id',
    header: 'Budget ID',
    type: 'text',
  },
  {
    id: 'start_date',
    header: 'Start Date',
    type: 'date',
  },
  {
    id: 'end_date',
    header: 'End Date',
    type: 'date',
  },
  {
    id: 'total_amount',
    header: 'Total',
    type: 'currency',
    style: { cell: 'cell-align-right', header: 'header-align-right' },
  },
  {
    id: 'used_amount',
    header: 'Used',
    type: 'currency',
    style: { cell: 'cell-align-right text-danger', header: 'header-align-right' },
  },
  {
    id: 'available_amount',
    header: 'Available',
    type: 'currency',
    editable: false,
    style: { cell: 'cell-align-right text-success', header: 'header-align-right' },
  },
  {
    id: 'is_archived',
    header: 'Is Archived',
    type: 'checkbox',
    style: { cell: 'cell-align-center', header: 'header-align-center' },
  },
];

export default columns.map(buildColumn);
